<!-- 个人绑定审核 -->
<template>
  <div>
    <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="15">
        <el-card class="box-card card">
          <el-row class="title-box">
            <el-col :span="24">
              <div class="grid-content bg-purple-dark info-box">
                <span class="title">个人绑定{{this.$route.query.text}}</span>
              </div>
            </el-col>
          </el-row>



          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <el-form :label-position="labelPosition" label-width="148px">
                  <el-form-item label="企业名称">
                    <el-input v-model="deteilData.companyName" readonly="readonly"
                              class="inp text-bg define-inp"></el-input>
                  </el-form-item>

                  <el-form-item label="负责人姓名">
                    <el-input v-model="deteilData.userName" readonly="readonly"
                              class="inp text-bg define-inp"></el-input>
                  </el-form-item>

                  <el-form-item label="负责人联系方式">
                    <el-input v-model="deteilData.tel" readonly="readonly" class="inp text-bg define-inp"></el-input>
                  </el-form-item>

                  <el-form-item label="性别">
                    <el-input v-model="gender" readonly="readonly" class="inp text-bg define-inp"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>

          <el-row type="flex" justify="center" class="btn-list" v-if="bindInfo.checkStatus==0">
            <el-col :span="13" style="text-align:center;">
              <el-button type="primary theme-btn" class="btn pass" @click.native="submitRemake(1,remake)">通过</el-button>
              <el-button class="btn refuse" @click.native="alertRemakeFn">拒绝</el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <!-- 审核理由对话框 -->
    <el-dialog
        :visible.sync="showRemake"
        width="30%"
    >
      <div>
        <el-input
            type="textarea"
            class="checkText"
            :rows="10"
            placeholder="请输入拒绝理由"
            maxlength="99"
            show-word-limit
            v-model="remake">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="showRemake = false">取 消</el-button>
                <el-button class="theme-btn" type="primary" @click.native="submitRemake(2,remake)">提 交</el-button>
            </span>
    </el-dialog>

  </div>
</template>
<script>

export default {
  data() {
    return {
      labelPosition: 'right',
      label: '统一社会信用代码\n或注册号',
      showRemake: false,
      deteilData: "",
      remake: '',  // 审核理由
      companyName: '', // 公司名称
      code: '',    // 统一社会信用代码或注册号
      srcList: [],     // 存放所有图片数据
      bindInfo: [],   // 所有数据
      businessLicense: '',  // 营业执照
      gender: "", // 性别
      ridlist: 0,
    }
  },
  props: ['item'],
  methods: {
    alertRemakeFn() {
      this.showRemake = true;
    },
    submitRemake(status, remake) {    // status 2 通过  3拒绝
      let id = this.ridlist
      let that = this
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.axiosPost(`/web/userBinding/checkout`,
          {
            id: id,
            updateEmp: userInfo.id,
            checkStatus: status,
            remake: remake
          }
      ).then((res) => {
        let status = res.code == 200 ? 'success' : 'error'
        this.$message({
          showClose: true,
          message: res.message,
          type: status,
          duration: 1500
        });
        this.$router.go(-1)
        that.$emit('statusFun', true)
      })
    },
    findVoById() {
      let id = this.ridlist
      this.axiosGet(`/web/userBinding/findVoById/${id}`).then((res) => {
        this.deteilData = res.data
        if (this.deteilData.gender == 1) {
          this.gender = '男'
        } else {
          this.gender = '女'
        }
        // //    console.log('个人绑定')
        // //    console.log(res)
        // this.companyName = res.data.companyName
        // this.code = res.data.registration
        // this.businessLicense = res.data.businessLicense
        // this.srcList.push(this.businessLicense)
        // this.bindInfo = res.data

        // this.findVoById()
      })
    },
  },
  created() {
    this.remake = ''  // 审核理由
    this.companyName = '' // 公司名称
    this.code = ''    // 统一社会信用代码或注册号
    this.srcList = []     // 存放所有图片数据
    this.bindInfo = []   // 所有数据
    this.businessLicense = ''  // 营业执照
    this.ridlist = this.$route.query.id
    let id = this.$route.query.id
    this.axiosGet(`/web/userBinding/findById/${id}`).then((res) => {
      console.log(res)
      this.companyName = res.data.companyName
      this.code = res.data.registration
      this.businessLicense = res.data.businessLicense
      this.srcList.push(this.businessLicense)
      this.bindInfo = res.data
      this.findVoById()
    })
  },
  components: {}
}
</script>
<style lang="less" scoped>
.inp {
  width: 80%;
  height: 40px;
  padding-left: 2%;
  border-radius: 4px;
}

.num {
  font-size: 48px;
  font-weight: 500;
  color: #197FFB;
  line-height: 74px;
  margin-right: 10px;
}

.info-box {
  padding-left: 50px;
}

.form {
  padding-left: 78px;
}

.title-box {
  margin: 20px 0;

  .title {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
    position: relative;
    bottom: 5px;
  }
}

.chck {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}

.el-col-offset-8 {
  margin-left: 40.3333%
}

.btn_fb {
  margin-top: 20px;
}

.image {
  width: 30%;
  height: 170px;
  margin-right: 3%;
}

.image:last-child {
  margin-right: 0;
}

.btn {
  width: 40%;
  height: 46px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 400;
}

.pass {
  margin-right: 51px;
}

.refuse {
  color: #1A80FC;
  background: #EEF2FB;
}


// .el-form-item__label{
//     white-space:pre-line;
//     text-align:left;
// }

// //如果是table的话就
// .el-table .cell{
//     white-space:pre-line;
// }


.row-bg {
  margin-top: 20px;
}

</style>
